// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"w8YMi","displayText":"_353_u"};